import { render, staticRenderFns } from "./DoubleTable.vue?vue&type=template&id=73d57cca"
import script from "./DoubleTable.vue?vue&type=script&lang=js"
export * from "./DoubleTable.vue?vue&type=script&lang=js"
import style0 from "./DoubleTable.vue?vue&type=style&index=0&id=73d57cca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports